export default __webpack_public_path__ + "static/media/bad-pizzas.80524c35.svg";